import type { RouteRecordRaw } from 'vue-router';

import { defaultLayoutProps } from '~/pages/layout';
import { ROUTE_KEYS } from '~/router';

const PrivacyPolicyRoute: RouteRecordRaw = {
	path: '/privacy-policy',
	name: ROUTE_KEYS.PRIVACY_POLICY,
	meta: {
		label: 'privacy-policy.page-title',
		auth: false
	},
	props: {
		...defaultLayoutProps
	},
	components: {
		default: () => import('./privacy-policy.page.vue'),
		appbar: () => import('~/components/shared/app-bar/app-bar.vue')
	}
};

export default PrivacyPolicyRoute;
